export function addTermsAndConditionsToCaption(
    caption: string | null,
    termsAndConditionsText: string | null,
    termsAndConditionsUrl: string | null,
): string {
    if (!termsAndConditionsText && !termsAndConditionsUrl) {
        return caption ?? '';
    } else if (!termsAndConditionsText) {
        return `${caption ?? ''}\n${termsAndConditionsUrl ?? ''}`;
    } else {
        return `${caption ?? ''}\n${termsAndConditionsText} ${termsAndConditionsUrl ?? ''}`;
    }
}
